import { render, staticRenderFns } from "./ProjectCredits.vue?vue&type=template&id=719d237e&scoped=true&"
import script from "./ProjectCredits.vue?vue&type=script&lang=js&"
export * from "./ProjectCredits.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCredits.vue?vue&type=style&index=0&id=719d237e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719d237e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
